import * as React from "react";
import { SVGProps } from "react";

const Seele = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 230 226" {...props}>
    <circle cx={115.03} cy={111.96} r={25} />
    <path d="M27.67 151.25A15.55 15.55 0 0 0 34 134.17a84.09 84.09 0 0 1 57.89-103 15.5 15.5 0 0 0-8.64-29.76 115.14 115.14 0 0 0-79.14 141 15.51 15.51 0 0 0 23.56 8.83ZM124 15.51a15.44 15.44 0 0 0 11.62 15 84 84 0 0 1 61.27 100.17 15.49 15.49 0 0 0 27.66 12.45 15.69 15.69 0 0 0 2.58-5.67A115.17 115.17 0 0 0 143.47.5a15.56 15.56 0 0 0-19 11.14 15.85 15.85 0 0 0-.47 3.87Zm72.15 152.06a15.22 15.22 0 0 0-20 2A84 84 0 0 1 57.4 173c-.42-.4-.84-.8-1.25-1.21a15 15 0 0 0-18.85-1.69l-.66.44a15.08 15.08 0 0 0-4.25 20.91 13.85 13.85 0 0 0 1.91 2.34 115 115 0 0 0 162.63-1.05c.67-.68 1.33-1.37 2-2.07a15.15 15.15 0 0 0-.64-21.4 14.94 14.94 0 0 0-1.51-1.25Z" />
  </svg>
);

export default Seele;
